<template>
    <default-modal
        ref="box"
        :title="title"
        :modalWidth="600"
        :confirmTxt="`开始协助`"
        @confirm="confirm"
    >
        <div
            class="commonLine"
            style="padding-left:70px;padding-top:20px;padding-bottom:10px"
        >
            <div class="left">
                <span>远程协助码：</span>
            </div>
            <div class="right">
                <input
                    type="text"
                    v-model="assistRemoteKey"
                    placeholder="请输入协助方提供的协助码，点击“开始协助”"
                />
            </div>
        </div>
    </default-modal>
</template>

<script>
import DefaultModal from "_c/modals/defaultModal";

import { useAssistBar } from "@/requests/bar";

export default {
    name: "barModals",
    components: {
        DefaultModal
    },
    data() {
        return {
            title: "远程协助",
            assistRemoteKey: ""
        };
    },
    computed: {},
    mounted() {
        window.$modal.toAssistModal = {};
        window.$modal.toAssistModal.show = () => {
            this.init();
        };
    },
    methods: {
        init() {
            this.assistRemoteKey = "";
            this.show();
        },
        show() {
            this.$refs.box.setWrong("");
            this.$refs.box.show();
        },
        async confirm() {
            if (this.assistRemoteKey == "") {
                this.$refs.box.setWrong("请输入远程协助码");
                return false;
            }
            let res = await useAssistBar({
                assistRemoteKey: this.assistRemoteKey
            });
            if (res.code == 200) {
                this.$refs.box.hide();
                this.$router.push({
                    path: "/home"
                });
                this.$router.push({
                    path: "/home/barManager/index/remoteRecord"
                });
                this.$store.dispatch("barDetails/actionUpdateBarAdminInfo");
            } else {
                return this.$refs.box.setWrong(res.msg);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/msgbox/_comMsg.scss";
.remoteAssistance {
    height: 200px;
}
</style>
